<template>
	<i :style="getOption().style" :class="getOption().class">
		<span style="color:#606266">
			{{ getOption().text }}
		</span>
	</i>
</template>

<script>
export default {
	name: 'activityState',

	props: {
		state: {
			type: String,
			required: true,
		},
		// icon: {
		// 	type: String,
		// 	required: true,
		// },
		// size: {
		// 	type: Number,
		// 	default: 15
		// }
	},

	components:{},

	data () {
		return {
		}
	},

	methods: {
		getOption() {
			switch (this.state) {
				case '待审批':
					return { text: this.state, style: 'color:#FFA937;', class: 'el-icon-info' }
					break;
				case '审批中':
					return { text: this.state, style: 'color:#1475EA;', class: 'el-icon-time' }
					break;
				case '已审批':
				case '已通过':
					return { text: this.state, style: 'color:#21D844;', class: 'el-icon-success' }
					break;
				case '已驳回': 
					return { text: this.state, style: 'color:red;', class: 'el-icon-error' }
					break;
			}
		},
		getClass() {
			return `el-icon-${this.icon}`
		},
		getStyle() {
			switch (this.icon) {
				case 'info':
				case 'time':
					return 'color:#FFA937;'
					break;
				case 'success':
					return 'color:#21D844;'
					break;
				case 'error':
					return 'color:#F42730;'
					break;
			}
		}
	},

	computed: {},

	mounted(){
	}
}
</script>

